export default "/storefront/client/images/logo_horizontal.png";